import { render, staticRenderFns } from "./TrainingReportsTable.vue?vue&type=template&id=f312fb86&"
import script from "./TrainingReportsTable.vue?vue&type=script&lang=js&"
export * from "./TrainingReportsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports